import React from 'react';

const Label = ({ text, modal }) => (
  <label className={`text-p z-10 lg:text-headingDark font-semibold ${modal ? ' text-headingDark' : 'text-white'} `}>{text}</label>
);

export default Label;
